export default __webpack_public_path__ + "static/mobilePhoneBlock-9b276e4560013a7c618c50e5b133b67b.jpg";